import cx from 'classnames';
import React from 'react';
import { useInView } from 'react-intersection-observer';

import * as styles from './Timeline.module.css';

const Timeline = ({ children }: { children: React.ReactNode }) => {
	return <ul className={styles.timeline}>{children}</ul>;
};

const Item = ({
	children,
	date,
}: {
	children: React.ReactNode;
	date: string;
}) => {
	const { ref, inView } = useInView({
		threshold: 1,
		triggerOnce: true,
	});

	return (
		<li ref={ref} className={cx(styles.item, { [styles.active]: inView })}>
			<div className={styles.box}>
				<div className={styles.overlay}>
					<p className={styles.inline}>{date}</p>
					{children}
				</div>
				<div className={styles.accent}></div>
			</div>

			<div className={styles.point}>
				<div className={styles.bullet}></div>
			</div>

			<p className={cx(styles.date, { [styles.active]: inView })}>{date}</p>
		</li>
	);
};

Timeline.Item = Item;

export default Timeline;
